module.exports = __webpack_public_path__ + "static/media/plain-box.576e6903.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/quotation-request/plain-box.png
// module id = 1632
// module chunks = 0